import Vue from 'vue'
import Router from 'vue-router'
import Search from './views/Search.vue'
import WordEditor from './views/WordEditor.vue'

Vue.use(Router)

// .env (開発環境では .env.development) で VUE_APP_IS_EDITABLE を設定
const isEditable = process.env.VUE_APP_IS_EDITABLE == "true"

const routes = [
  {
    path: '/',
    name: 'search',
    component: Search
  },
]

if (isEditable) {
  routes.push({
    path: '/admin/word/:wordId',
    name: 'admin_word_edit',
    component: WordEditor
  })
}

export default new Router({
  routes
})
